import type MailboxType from './MailboxType';
import type { MailboxProvider } from './MailboxProvider';

export default function getMailboxTypeForBizchatTelemetry(
    mailboxProvider: MailboxProvider | null | undefined,
    mailboxType: MailboxType
): string | undefined {
    if (mailboxType === 'SharedMailbox') {
        return 'Shared';
    }

    switch (mailboxProvider) {
        case 'Office365':
        case 'Outlook':
            return '1stParty';
        case 'Google':
        case 'Yahoo':
        case 'ICloud':
        case 'IMAP':
        case 'POP3':
        case 'PstFile':
        case 'MessageFile':
            return '3rdParty';
        default:
            return undefined;
    }
}
